import { QarepaEnumInformation } from '@qarepa/common';

export enum ProjectStatusEnum {
  PENDING = 'PENDING',
  PROGRESS = 'PROGRESS',
  INACTIVE = 'INACTIVE',
  CANCELLED = 'CANCELLED',
  FINISHED = 'FINISHED',
}

export type ProjectStatusType =
  | ProjectStatusEnum.PENDING
  | ProjectStatusEnum.PROGRESS
  | ProjectStatusEnum.INACTIVE
  | ProjectStatusEnum.CANCELLED
  | ProjectStatusEnum.FINISHED;

export const ProjectStatusArray = [
  ProjectStatusEnum.PENDING,
  ProjectStatusEnum.PROGRESS,
  ProjectStatusEnum.INACTIVE,
  ProjectStatusEnum.CANCELLED,
  ProjectStatusEnum.FINISHED,
];

export const ProjectStatusInfo: QarepaEnumInformation<ProjectStatusEnum> = {
  [ProjectStatusEnum.PENDING]: {
    name: $localize`Por iniciar`,
  },
  [ProjectStatusEnum.PROGRESS]: {
    name: $localize`En progreso`,
  },
  [ProjectStatusEnum.INACTIVE]: {
    name: $localize`En pausa`,
  },
  [ProjectStatusEnum.CANCELLED]: {
    name: $localize`Cancelado`,
  },

  [ProjectStatusEnum.FINISHED]: {
    name: $localize`Completado`,
  },
};
